module.exports = __webpack_public_path__ + "static/media/mastercard.f70493ab.svg";